import { Component, OnInit, Input, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingService } from 'src/app/core/service/setting.service';
import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserService } from 'src/app/core/service/user.service';
import { FhirService } from 'src/app/core/service/fhir.service';

@Component({
  standalone: false,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit
{
  @Input() public title: string;
  @Input() public dob: string;
  @Input() public breadcrumb: string;
  @Input() public isStringLiteral = false;
  @Input() public count: number;
  @Input() public countBgColor: string;
  @Input() public styleBreadcrumb: string;
  @Input() public icon: string;
  @Input() public isFhir: boolean = false;

  public isShowHome = false;

  constructor(
    private translate: TranslateService,
    private settingService: SettingService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private fhirService: FhirService,
    @Inject(DOCUMENT) private document: any,
    @Inject(APP_BASE_HREF) private baseHref: string) { }

  public ngOnInit(): void
  {
    if (this.title !== '' && this.title !== undefined)
    {
      this.translate.get(this.title).subscribe({
        next: (res: string) =>
        {
          this.settingService.getCachedSessionSettings().subscribe({
            next: (sessionSetting) =>
            {
              if (res.includes('{{patientLabel}}'))
              {
                this.title = res.replace('{{patientLabel}}', sessionSetting.patientLabel);
              }
              else
                if (res.includes('{{communityLabel}}'))
                {
                  this.title = res.replace('{{communityLabel}}', sessionSetting.communityLabel);
                }
                else
                {
                  this.title = res;
                }
            }
          });
        }
      });
    }
    this.setHomeButtonVisibility();
  }

  public openFullSite(): void
  {
    const tokenData = encodeURIComponent(JSON.stringify(this.authenticationService.currentUser));
    const fhirPatient = encodeURIComponent(JSON.stringify(this.fhirService.patientContext));
    window.open(`${this.document.location.origin}${this.baseHref}cases/active?token=${tokenData}&fhirPatient=${fhirPatient}`, '_blank');
  }

  private setHomeButtonVisibility(): void
  {
    this.isShowHome = false;
    if (this.authenticationService.isAuthenticated && this.authenticationService.currentUser && this.authenticationService.currentUser.id) 
    {
      this.userService.getUserById(this.authenticationService.currentUser.id, false).subscribe({
        next: (data) =>
        {
          this.isShowHome = !data.ehrOnlyAccess;
        }
      });
    }
  }
}
